import { PrivateRoute } from 'hoc/PrivateRoute';
import { PublicRoute } from 'hoc/PublicRoute';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router';
import { refreshUser } from 'redux/auth/operations';
// import { selectIsRefreshing } from 'redux/auth/selector';

import Home from './Home';
import Layout from './Layout';
// import Loader from './Loader';
import Login from './Login';
import Phonebook from './Phonebook';
import Register from './Register';

// import style from './app.module.scss';

export const App = () => {
  const dispatch = useDispatch();

  // const isLoading = useSelector(selectIsRefreshing);

  useEffect(() => {
    dispatch(refreshUser());
  }, [dispatch]);

  // return
  // isLoading ? (
  //   <div className={style.loaderApp}>
  //     <Loader />
  //   </div>
  // ) :
  return (
    <div>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />}></Route>
          <Route
            path="/contacts"
            element={
              <PrivateRoute>
                <Phonebook />
              </PrivateRoute>
            }
          ></Route>
          {/* <Route path="/login" element={<Login />}></Route> */}
          <Route
            path="login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          ></Route>
          <Route path="/register" element={<Register />}></Route>
        </Route>
      </Routes>
    </div>
  );
};
